import { Layout } from "../../layouts/v1";
import { MainView } from "../../views/stock-cycle/root";
import { AnalysisVersionContextProvider } from "../../views/stock-cycle/root/contexts/AnalysisVersionContext";
import { ProductCategoriesContextProvider } from "../../views/stock-cycle/root/contexts/ProductCategoriesContext";
import { PurchaseInfosContextProvider } from "../../views/stock-cycle/root/contexts/PurchaseInfosContext";
import { SelectedShoppingCartStageContextProvider } from "../../views/stock-cycle/root/contexts/SelectedShoppingCartStageContext";
import { SettingVariablesContextProvider } from "../../views/stock-cycle/root/contexts/SettingVariablesContext";
import { SheetItemListContextProvider } from "../../views/stock-cycle/root/contexts/SheetItemListContext";
import { ShoppingCartStagesContextProvider } from "../../views/stock-cycle/root/contexts/ShoppingCartStagesContext";
import { StockCycleDatasContextProvider } from "../../views/stock-cycle/root/contexts/StockCycleDatasContext";

export function StockCyclePage(props) {
    return (
        <>
            <SettingVariablesContextProvider>
                <ProductCategoriesContextProvider>
                    <AnalysisVersionContextProvider>
                        <StockCycleDatasContextProvider>
                            <SheetItemListContextProvider>
                                <ShoppingCartStagesContextProvider>
                                    <SelectedShoppingCartStageContextProvider>
                                        <PurchaseInfosContextProvider>
                                            <Layout>
                                                <MainView />
                                            </Layout>
                                        </PurchaseInfosContextProvider>
                                    </SelectedShoppingCartStageContextProvider>
                                </ShoppingCartStagesContextProvider>
                            </SheetItemListContextProvider>
                        </StockCycleDatasContextProvider>
                    </AnalysisVersionContextProvider>
                </ProductCategoriesContextProvider>
            </SettingVariablesContextProvider>
        </>
    );
}
